import { ModelBase } from "./ModelBase"


export class StressTestListModel extends ModelBase {
    Lista: Array<StressTestListItem>
    IsUser: boolean
}

export class StressTestListItem {
    Id: string
    Periodo: Date
    MeseIncasso: Date
    MeseZeroIncasso: Date
    NomeStressTest: string
}


export class StressTestRow  {
    Id: string
    ParentId: string
    Valori: Array<number>
    IsRettifica: boolean
    Descrizione: string
    children?: Array<StressTestRow>
}

export class StressTestBaseModel extends ModelBase {
    SaldoCC: number = 0
    FidiCassa: number = 0
    MeseRiferimento: Date
    NomeStressTest: string
    Uscite: Array<StressTestRow>
    Entrate: Array<StressTestRow>
}

export class StressTestModel extends StressTestBaseModel {
    Risultati: Array<StressTestRow> // Liquidità + STRESS TEST (0 incassi)

    PrevCorretteLiquidita: Date
    ZeroIncassiLiquidita: Date
}

export class StressTestInputModel extends StressTestBaseModel {
    RowId: string
    Value: number
    MonthIndex: number
}

export class StressTestRettificaModel extends ModelBase {
    Nota: string
    StressTestDetailId: string
    StressTestId: string
    VariazionePerc?: number
    VariazioneValuta?: number
    VariazioneType: string
    NrMesi?: number
    MeseIniziale?: number
}

export class StressTestRettificheRowModel extends ModelBase {
    Rows: Array<StressTestRow>
}

//export class StressTestRettificheRow extends StressTestRowBase {
//    // edit e delete?
//}
